module.exports = __webpack_public_path__ + "img/img13.f6c7d58c.svg";